import React, { useEffect } from "react";
import NavbarItem from '../Header/Navbar/NavbarItem' 

const MobileMenu = () => {
  useEffect(() => {
    // Clicking anywhere outside the open menu closes it (clicks on the
    // hamburger button are excluded so opening doesn't instantly close).
    // Registered unconditionally so its cleanup/re-register survives
    // StrictMode's double mount.
    const handleOutsideClick = (e) => {
      const menu = document.querySelector("#offcanvas-mobile-menu");
      if (!menu || !menu.classList.contains("active")) return;
      if (e.target.closest("#offcanvas-mobile-menu") || e.target.closest(".mobile-aside-button")) return;
      menu.classList.remove("active");
    };
    document.addEventListener("click", handleOutsideClick);

    // One-time DOM setup below (expand arrows + listeners on menu nodes).
    // The guard keeps re-runs from inserting duplicates; the DOM it decorates
    // persists across StrictMode remounts, so its listeners survive too.
    const offCanvasNav = document.querySelector("#offcanvas-navigation");
    if (offCanvasNav && !offCanvasNav.querySelector(".menuExpand")) {
      const offCanvasNavSubMenu = offCanvasNav.querySelectorAll(`.subMenu`);
      const anchorLinks = offCanvasNav.querySelectorAll("a");

      for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
        offCanvasNavSubMenu[i].insertAdjacentHTML(
          "beforebegin",
          `<span class="menuExpand"><i></i></span>`
        );
      }

      const menuExpand = offCanvasNav.querySelectorAll(".menuExpand");

      for (let i = 0; i < menuExpand.length; i++) {
        menuExpand[i].addEventListener("click", e => {
          sideMenuExpand(e);
        });
      }

      for (let i = 0; i < anchorLinks.length; i++) {
        const parentLi = anchorLinks[i].closest("li");
        const isSubmenuParent =
          parentLi &&
          parentLi.classList.contains("menuItemHasChildren") &&
          anchorLinks[i].parentElement === parentLi;
        if (!isSubmenuParent) {
          anchorLinks[i].addEventListener("click", () => {
            closeMobileMenu();
          });
        }
      }

      // Tapping anywhere on a parent row (the "Services" text, the space beside
      // it, or the row itself) expands/collapses its submenu instead of
      // navigating. The expand icon and submenu links keep their own handlers.
      const parentRows = offCanvasNav.querySelectorAll("li.menuItemHasChildren");
      for (let i = 0; i < parentRows.length; i++) {
        parentRows[i].addEventListener("click", (e) => {
          if (e.target.closest(".subMenu") || e.target.closest(".menuExpand")) return;
          e.preventDefault();
          parentRows[i].classList.toggle("active");
        });
      }
    }

    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const sideMenuExpand = e => {
    e.currentTarget.parentElement.classList.toggle("active");
  };

  const closeMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.remove("active");
  };

  return (
    <div className="offcanvasMobileMenu" id="offcanvas-mobile-menu">
      <button
        className="offcanvasMenuClose"
        id="mobile-menu-close-trigger"
        onClick={() => closeMobileMenu()}
      >
      <i className="icon_close"></i>
      </button>

      <div className="offcanvasWrapper">
        <div className="offcanvasInnerContent">

          <nav className="offcanvasNavigation" id="offcanvas-navigation">
            <ul>
               
              <NavbarItem />

            </ul>
          </nav>

          {/* Search Form */}
          {/* <div className="offcanvasMobileSearchArea">
            <form action="#">
              <input type="search" placeholder="Search ..." />
              <button type="submit"> 
              </button>
            </form>
          </div> */}

          {/* Contact Info  */} 

          <div className="header_top_right list-unstyled">
            <ul>
              <a href="tel:2066366961">
                <li>
                  <i className="fa fa-phone"></i> (206) 636-6961
                </li>
              </a>
              <li>
              <i className="fa fa-envelope"></i> info@navysealsmoving.com
              </li>
            </ul>
          </div>

          {/* Social Icon*/}
          <div className="header_top_left">
            <ul className="header_socil list-inline">   
                <li>
                  <a target="_blank" rel="noopener noreferrer" href="https://goo.gl/maps/cUrKYLa1WfEjfajX8"><i className="fab fa-google"></i></a>
                </li>
                <li>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.yelp.ca/biz/navy-seals-moving-tukwila"> <i className="fab fa-yelp"></i></a>
                </li>
                <li>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/@navysealsmoving7695/videos"><i className="fab fa-youtube-square"></i></a>
                </li>
                <li>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=100066631421741"><i className="fab fa-facebook"></i></a>
                </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
